import React, { useEffect, useRef } from 'react';

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export default function MessageDialog(props) {

	let { title, label, closeCallback } = props;
	
	const textRef = useRef();
	
	useEffect(() => {
    	textRef.current.focus();
  	}, []);
  	
	return (
		<Dialog 
			title={title} 
			onClose={closeCallback}
		>
			<p 
				style={{
					margin: "25px",
					textAlign: "center"
				}}
				tabIndex="0"
			>
				{label}
			</p>
	        <DialogActionsBar>
				<button 
					ref={textRef}
					className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
					onClick={closeCallback}
				>
					Close
				</button>
	        </DialogActionsBar>
		</Dialog>
	);
}